<template>
    <div class="userStatistics">
        <div>
            <el-date-picker v-model="date" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
                :picker-options="startDateDisabled" start-placeholder="开始日" end-placeholder="结束日" class="pulic_cursor">
            </el-date-picker>
            <span class="search_btn" @click="search">查询</span>
        </div>
        <!-- 用户统计 -->
        <div class="statistic_box">
            <div class="statistic_box_item">
                <div class="statistic_box_item_title">累计用户数</div>
                <div class="statistic_box_item_num">{{ userCount }}</div>
            </div>
            <div class="statistic_box_item statistic_box_item2">
                <div class="statistic_box_item_title">外部浏览量</div>
                <div class="statistic_box_item_num">{{ recordCount }}</div>
            </div>
            <div class="statistic_box_item">
                <div class="statistic_box_item_title">新增用户</div>
                <div class="statistic_box_item_num">{{ addUserCount }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            date: [],
            userCount: 0,
            addUserCount: 0,
            recordCount: 0,
            startDateDisabled: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            }
        }
    },
    created() {
        this.getNowDay();
    },
    methods: {
        search() {
            if (!this.date) {
                this.$message.warning("请选择时间");
                return;
            }
            this.getData();
        },
        getNowDay() {
            var date = new Date().getTime();
            var nowDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(date));
            this.date = [nowDay, nowDay];
            this.getData();
        },
        getData() {
            var loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            this.axios.post('/userStatistics/queryCount', { startTime: `${this.date[0]} 00:00:00`, endTime: `${this.date[1]} 23:59:59` }).then(res => {
                if (res.data.code == 200) {
                    this.recordCount = res.data.data.recordCount;
                    this.addUserCount = res.data.data.addUserCount;
                    this.userCount = res.data.data.userCount;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    });
                }
                setTimeout(() => {
                    loading.close()
                }, 300)
            }).catch(() => {
                loading.close()
            })
        }
    }
}
</script>
<style scoped>
.userStatistics {
    width: 100%;
    min-height: 100vh;
    padding: 20px;
    box-sizing: border-box;
}

.statistic_box {
    display: flex;
    justify-content: space-around;
    margin-top: 40px;
}

.statistic_box_item {
    width: 33%;
    text-align: center;
}

.statistic_box_item_title {
    font-size: 20px;
    margin-bottom: 10px;
    font-weight: 700;
}

.statistic_box_item2 {
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
}

.search_btn {
    display: inline-block;
    width: 80px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: rgb(25, 159, 255, 1) !important;
    color: #fff;
    cursor: pointer;
    margin-left: 20px;
}
</style>